const backToTopButton = document.querySelector('.app-back-to-top')

backToTopButton.addEventListener("click", () => {
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
})